import * as React from 'react';

import { isAdmin, isOpsAdmin, isAllModuleAccessUser } from './constants';
import { Page } from './types';
import { ComponentBox } from '../component/ComponentBox';
import { IS_PROD } from '../config';

export const Home = () => {
  const showUserManagementLink = isOpsAdmin() || isAdmin() || isAllModuleAccessUser();
  const showDiscountsLink = isOpsAdmin() || isAdmin() || isAllModuleAccessUser();
  const showItemsManagementLink = isOpsAdmin() || isAllModuleAccessUser();
  const showPromotionsLink = isAllModuleAccessUser();
  const showFetchAiLink = !IS_PROD && isAllModuleAccessUser();
  const showOnCallDashboardLink = isAllModuleAccessUser();
  const showCommandExecutionLink = isAllModuleAccessUser();

  // 3 always-visible: CustomerLookup, DiscountLookup, ProductPricingNutrientInfo
  const moduleCount =
    3 +
    [
      showUserManagementLink,
      showDiscountsLink,
      showItemsManagementLink,
      showPromotionsLink,
      showFetchAiLink,
      showOnCallDashboardLink,
      showCommandExecutionLink,
    ].filter(Boolean).length;

  const containerClass =
    moduleCount > 5 ? 'grid grid-cols-2 gap-6 max-w-4xl w-full pt-12' : 'flex flex-col gap-6';

  return (
    <div className="min-h-[calc(100vh-77px)] bg-slate50 py-8 px-4 flex flex-col items-center">
      <div className={containerClass}>
        {showUserManagementLink && <ComponentBox title="Manage Users" page={Page.UserManagement} />}
        <ComponentBox title="Customer Lookup" page={Page.CustomerLookup} />
        <ComponentBox title="Discount Lookup" page={Page.DiscountLookup} />
        {showDiscountsLink && <ComponentBox title="Manage Discounts" page={Page.DiscountsPage} />}
        {showItemsManagementLink && (
          <ComponentBox title="Manage Products & Items" page={Page.ManageDataPage} />
        )}
        {showPromotionsLink && (
          <ComponentBox title="Manage Promotions" page={Page.PromotionsPage} />
        )}
        <ComponentBox
          title="Product, Pricing, Nutrient Info"
          page={Page.ProductPricingNutrientInfo}
        />
        {showFetchAiLink && <ComponentBox title="FETCH AI" page={Page.FetchAiPage} />}

        {showOnCallDashboardLink && (
          <ComponentBox title="On-Call Dashboard" page={Page.OnCallDashboard} />
        )}

        {showCommandExecutionLink && (
          <ComponentBox title="Command Runner" page={Page.CommandRunner} />
        )}
      </div>
    </div>
  );
};
